/**
 * Sort and organize CRF items by safeguard category and then by topic
 * @param {Array} items - Array of CRF items to organize
 * @returns {Object} Organized data structure
 */
(function($) {
	function sortAndOrganizeItems(items) {
		// First, sort items by safeguardcategory, then by safeguardtopic, and then by safeguardprioritytag
		items.sort((a, b) => {
			if (a.safeguardcategories.S !== b.safeguardcategories.S) {
				return a.safeguardcategories.S.localeCompare(b.safeguardcategories.S);
			} else if (a.safeguardtopic.S !== b.safeguardtopic.S) {
				return a.safeguardtopic.S.localeCompare(b.safeguardtopic.S);
			} else {
				return a.safeguardprioritytag.S.localeCompare(b.safeguardprioritytag.S);
			}
		});

		// Organize items into a structured object
		const organizedData = items.reduce((acc, item) => {
			const category = item.safeguardcategories.S;
			const topic = item.safeguardtopic.S;

			if (!acc[category]) {
				acc[category] = {};
			}
			if (!acc[category][topic]) {
				acc[category][topic] = [];
			}
			acc[category][topic].push(item);
			return acc;
		}, {});
		return organizedData;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = sortAndOrganizeItems;
	} else if (typeof window !== 'undefined') {
		window.sortAndOrganizeItems = sortAndOrganizeItems;
	}

})(jQuery);